var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 11.4998V15.4998C4 16.3298 4.67 16.9998 5.5 16.9998C6.33 16.9998 7 16.3298 7 15.4998V11.4998C7 10.6698 6.33 9.99982 5.5 9.99982C4.67 9.99982 4 10.6698 4 11.4998ZM10 11.4998V15.4998C10 16.3298 10.67 16.9998 11.5 16.9998C12.33 16.9998 13 16.3298 13 15.4998V11.4998C13 10.6698 12.33 9.99982 11.5 9.99982C10.67 9.99982 10 10.6698 10 11.4998ZM3.5 21.9998H19.5C20.33 21.9998 21 21.3298 21 20.4998C21 19.6698 20.33 18.9998 19.5 18.9998H3.5C2.67 18.9998 2 19.6698 2 20.4998C2 21.3298 2.67 21.9998 3.5 21.9998ZM16 11.4998V15.4998C16 16.3298 16.67 16.9998 17.5 16.9998C18.33 16.9998 19 16.3298 19 15.4998V11.4998C19 10.6698 18.33 9.99982 17.5 9.99982C16.67 9.99982 16 10.6698 16 11.4998ZM10.57 1.48982L2.67 5.64982C2.26 5.85982 2 6.28982 2 6.74982C2 7.43982 2.56 7.99982 3.25 7.99982H19.76C20.44 7.99982 21 7.43982 21 6.74982C21 6.28982 20.74 5.85982 20.33 5.64982L12.43 1.48982C11.85 1.17982 11.15 1.17982 10.57 1.48982Z",
    fill: "#3783FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.41e2a8e82657d02ed4188b6c7dcb9562.svg";
export { ForwardRef as ReactComponent };